export declare const ToPic: any;
export default ToPic;
export * from './src/pic';
